import { FC, ReactNode, SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import CheckmarkIcon from 'dibs-icons/exports/Checkmark';
import styles from './styles/DropdownItem.scss';

type ReduxStoreType = {
    header: {
        isNavigationRefreshVariant: boolean;
    };
};

type Props = {
    onClick: (event: SyntheticEvent) => void;
    label: ReactNode;
    selected: boolean;
    dataTn: string;
    id: string;
    focused: boolean;
    isNavigationRefreshVariant: boolean;
};

const DropdownItem: FC<Props> = ({
    focused,
    id,
    onClick,
    label,
    selected,
    dataTn,
    isNavigationRefreshVariant,
}) => {
    if (isNavigationRefreshVariant && selected) {
        return null;
    }

    const optionClassName = classnames(styles.option, {
        [styles.focused]: focused,
        [styles.navigationRefreshOption]: isNavigationRefreshVariant,
    });

    return (
        <li
            id={id}
            role="option"
            onClick={onClick}
            onKeyDown={onClick}
            aria-selected={focused ? 'true' : 'false'}
            className={optionClassName}
            data-tn={dataTn}
        >
            {selected && <CheckmarkIcon className={styles.checkmark} />}
            <span className={styles.optionLabel}>{label}</span>
        </li>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isNavigationRefreshVariant: boolean;
} => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default connect(mapStateToProps)(DropdownItem);
